<template>
  <div class = "homePage"  >
    <banner></banner>
    <homeNew></homeNew>
    <cptj id="cptj"></cptj>
    <geography id= 'geography'></geography>
    <indicator id= 'indicator' v-if = 'result.classShowFlag == 1'></indicator>
    <fwpt id="fwpt" v-if = 'result.flavourShowFlag == 1'></fwpt>
    <kpjd id="kpjd" v-if = 'result.scienceShowFlag == 1'></kpjd>
    <fxgk id="fxgk" v-if = 'result.riskShowFlag == 1'></fxgk>
    <tjjg v-if = 'result.linkShowFlag == 1 '></tjjg>


    <div class = 'posiBox'>
      <a class = 'itembox'  href="#cptj">
        <img class = 'itemImg' src="../../../static/images/cptjlt.svg" alt="">
        <a  class="louti">{{result.seasonTitle}}</a>
      </a>
      <a class = 'itembox'  href="#geography">
        <img class = 'itemImg' src="../../../static/images/dlcxlt.svg" alt="">
        <a  class="louti">{{result.distributionTitle}}</a>
      </a>
      <a class = 'itembox'  href="#indicator" v-if = "result.classShowFlag == 1 ">
        <img class = 'itemImg' src="../../../static/images/tzzblt.svg" alt="">
        <a class="louti">{{result.classTitle}}</a>
      </a>
      <a class = 'itembox' href="#fwpt" v-if = "result.flavourShowFlag == 1 ">
        <img class = 'itemImg' src="../../../static/images/fwptlt.svg" alt="">
        <a  class="louti">{{result.flavourTitle}}</a>
      </a>
      <a class = 'itembox' href="#kpjd" v-if = "result.scienceShowFlag == 1 ">
        <img class = 'itemImg' src="../../../static/images/kpjllt.svg" alt="">
        <a  class="louti">{{result.scienceTitle}}</a>
      </a>
      <a class = 'itembox' href="#fxgk" v-if = "result.riskShowFlag == 1 ">
        <img class = 'itemImg' src="../../../static/images/fxgklt.svg" alt="">
        <a  class="louti">{{result.riskTitle}}</a>
      </a>
      <a class = 'itembox' @click = 'handleclickfankui'> 
        <img class = 'itemImg' src="../../../static/images/yjfk.svg" alt="">
        <span  class="louti">意见反馈</span>
      </a>
      
    </div>
    <div class="fanhui" v-show="elFadeInshow1" @click="zhankaiFn">
          <img class = 'itemImg' src="../../../static/images/fanhui.png" alt="">
        </div>
    <div class="questIonnaire" v-if="Array.isArray(adverMageList) && adverMageList.length != 0">
        <transition name="el-fade-in">
          <!-- indicator-position="none" -->
          <div v-show="elFadeInshow" class="questIonnaire_box">
            <el-carousel height="200px"  arrow="never" >
              <div class="fanhui1" @click="zhankaiFn1">
                <img class = 'itemImg' src="../../../static/images/fanhui1.png" alt="">
              </div>
              <div class="quxiao" @click="quxiaoFn">
                <img class = 'itemImg' src="../../../static/images/quxiao.png" alt="">
              </div>
              <el-carousel-item v-if="adverMageList.length>1" v-for="(item,index) in adverMageList" :key="index">
                <div class="questIonnaire_box_img" @click="questFn(item)">
                  <img :src="commonUrl+item.adverImage" alt="">
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="questIonnaire_box_img" v-for="(item,index) in adverMageList" :key="index" @click="questFn(item)" v-if="adverMageList.length==1">
              <img :src="commonUrl+item.adverImage" alt="">
            </div>
            
          </div>
        </transition>
      </div>
    
    <backtop :showIdea = 'showIdea' @closefankui = 'closefankui'></backtop>
  </div>
</template>

<script>

import banner from './compontents/banner';
import kpjd from './compontents/kpjd';
import fwpt from './compontents/fwpt';
import geography from './compontents/geography'
import indicator from './compontents/indicator';
import fxgk from './compontents/fxgk';
import cptj from './compontents/cptj';
import homeNew from './compontents/news';
import tjjg from './compontents/tjjg';
import  backtop from "../../components/backtop/index.vue";


export default {
  components: {
    banner,kpjd,fwpt,geography,indicator,fxgk,cptj,homeNew,backtop,tjjg
  },
  mounted() {
    this.getshowInfo()
    this.addFangwenNum()
    this.getTypeId();
    this.commonUrl =commonUrl;
  },
  data () {
    return {
      showIdea:false,
      result:{
        classShowFlag :'1',//特征指标(0:不显示1:显示)
        flavourShowFlag:'1',// 风味谱图(0:不显示1:显示)
        riskShowFlag :'1',//风险管控(0:不显示1:显示)
        scienceShowFlag:'1',// 科普解读(0:不显示1:显示)
        seasonTitle:'产品推荐',//产品推荐标题
        distributionTitle:'产品分布',//产品分布标题
        classTitle:'特征指标',//特征指标标题
        flavourTitle:'风味谱图',//风味谱图标题
        scienceTitle:'科普解读',//科普解读标题
        riskTitle:'风险管控',//风险管控标题

      },
      commonUrl,
      wenjuanId:'',
      adverMageList:[],
      elFadeInshow:true,
      elFadeInshow1:false,
    }
  },
  methods: {
    addFangwenNum() {//访问数量+1
      if( sessionStorage.getItem("addFlag") ){
        return;
      }
      this.Axios({
        url: Action.UNLOGIN_VISITS,
        method: "post",
        data: {
          sysUserId: ''
        }
      }).then(res => {
        res = res.data;
        if (res.code == "000") {
          sessionStorage.setItem("addFlag", "1");
        } else {
          this.$alert(res.msg || "系统错误...", "错误提示", {
            cofirmButtonText: "确定",
            type: "error"
          });
        }
      })
    },
    handleclickfankui(){
      console.log(1111)
      this.showIdea = true
    },
    closefankui(){
      this.showIdea = false
    },
    getTypeId(){  // 获取广告接口为
      // 
      this.Axios({
        method:"post",
        url:Action.PROTAL_ADVERSPACELIST,
        data:{
         
        }
      }).then(res =>{
          if(res.data.code === '000'){
            console.log(res.data.result,"12233")
            res.data.result.forEach(  item => {
              if(item.adverSpaceType  == '10'){
                this.wenjuanId = item.id;
              }
            });
            this.getggList()
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },
    getshowInfo(){
      this.Axios({
        method:"post",
        url:Action.FLOORINDEX_INDEXSHOWFLAG,
        data:{
         
        }
      }).then(res =>{
          if(res.data.code === '000'){
            this.result = res.data.result
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },
    getggList(){
      this.Axios({
        method:"post",
        url:Action.PROTAL_ADVER_LIST,
        data:{
         id: this.wenjuanId
        }
      }).then(res =>{
          if(res.data.code === '000'){
            this.adverMageList = res.data.result[0].adverMageListVos;
            if(this.adverMageList && this.adverMageList.length == 0 ){
              this.elFadeInshow = false;
              this.elFadeInshow1 = false;
            }else{
              setTimeout(()=>{
                this.elFadeInshow = false;
                this.elFadeInshow1 = true;
              },5000)
            }
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },
    questFn(item){
      if(item.linkType == '1'){
        window.open(item.linkAddress,'_blank')
      }
    },
    quxiaoFn(){
      this.elFadeInshow = false;
      this.elFadeInshow1 = false;
    },
    zhankaiFn(){
      this.elFadeInshow = true;
      this.elFadeInshow1 = false;
    },
    zhankaiFn1(){
      this.elFadeInshow = false;
      setTimeout(()=>{
        this.elFadeInshow1 = true;
      },300)
      
    }


  },
 
}
</script>


<style lang="less" scoped>
.homePage{
  
  .posiBox{
    width: 76px;
	  background-color: #f2f5fa;
    box-shadow: 0px 2px 8px 0px 
      #efefef;
    border-radius: 5px;
    position:fixed;
    right:10px;
    top:100px;
    z-index:600;
    box-sizing: border-box;
    padding:10px 0;
    box-sizing: border-box;
    .itembox{
      width:76px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .itemImg{
        width: 44px;
	      height: 44px;
        margin:10px 0 10px;
      }
      .louti{
        width: 56px;
        line-height: 20px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #222222;
        text-align: center;
        // margin-top:5px;
      }
    }
    .itembox:hover .louti{
      color: #2c6eff;
    }
    
    .louti:hover{
      color: #2c6eff;
    }
    
  }
  .fanhui{
      position:fixed;
      bottom: 100px;
      right:10px;
      width: 20px;
      height: 40px;
      background-color: rgba(000, 000, 000, 0.48);
      display: flex;
      justify-content: center;
      align-items: center;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      cursor: pointer;
      z-index: 1011;
      img{
        width: 10px;
        height: 18px;
      }
    }
  .questIonnaire{
      position:fixed;
      bottom: 65px;
      right:10px;
      z-index: 999;
      .questIonnaire_box{
        width: 160px;
        position: relative;
        bottom: -60px;
        height: 200px;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        z-index: 112;
        /deep/ .el-carousel__indicators .el-carousel__indicator {
          width: 7px; /* 修改指示器的宽度 */
          height: 7px; /* 修改指示器的高度 */
          background-color: rgba(000, 000, 000, 0.5); /* 修改指示器的背景色 */
          border-radius: 50%; /* 设置为圆形 */
          margin-right:3px;
          margin-bottom: 8px;
        }
        /deep/ .el-carousel__indicators .el-carousel__indicator.is-active {
          background-color: rgba(000, 000, 000, 0.9);
          transform: scale(1.1); /* 放大选中时的指示器 */
        }
        /deep/ .el-carousel__indicator--horizontal{
          padding: 0;
        }
        /deep/ .el-carousel__indicator.is-active button{
          display: none;
        }
        /deep/ .el-carousel__indicator button{
          display: none;
        }
        .fanhui1{
        //  margin-top: 70px; 
          position: relative;
          top: 80px;
          width: 20px;
          height: 40px;
          background-color: rgba(000, 000, 000, 0.48);
          display: flex;
          justify-content: center;
          align-items: center;
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          cursor: pointer;
          z-index: 990;
          img{
            width: 10px;
            height: 18px;
          }
        }
        .quxiao{
          width:10px;
          height: 10px;
          position: absolute;
          top: 4px;
          right: 4px;
          cursor: pointer;
          z-index: 999;
        }
        .questIonnaire_box_img{
          width: 160px;
          height: 200px;
          position: absolute;
          top: 0;
          img{
            width: 100%;
            height: 200px;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
          }
        }
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/homePage/homePage.vue